import React from 'react';
import { parseWeight } from '@/utils/weights';

const P_KEYS = ['parcial_1', 'parcial_2', 'parcial_3'];

const gradeColor = (grade, w) =>
  grade >= (w / 100 * 8) ? 'text-green-700 bg-green-50' : grade >= (w / 100 * 6) ? 'text-yellow-700 bg-yellow-50' : 'text-red-700 bg-red-50';

export const AttendanceGradesSection = ({ attWeights, onWeightChange, isReadOnly, students, attendanceByParcial }) => {
  const hasAnyWeight = P_KEYS.some(k => parseWeight(attWeights[k]) > 0);
  return (
    <div className="mt-6 border-t-2 border-orange-100 pt-4" data-testid="att-grades-section">
      <h3 className="text-lg font-semibold text-orange-700 mb-1">Asignación de peso(%) para Asistencias</h3>
      <p className="text-xs text-slate-500 mb-3">Opcional. Si asignas un peso, el % de asistencia del parcial se suma a la calificación total en Evaluación.</p>
      <div className="flex flex-wrap gap-4 mb-4">
        {[1, 2, 3].map(p => (
          <div key={p} className="flex items-center gap-2 bg-orange-50 rounded-lg px-3 py-2">
            <span className="text-sm font-medium text-orange-700">Parcial {p}:</span>
            <input
              type="text"
              inputMode="decimal"
              maxLength={5}
              value={attWeights[`parcial_${p}`] || ''}
              onChange={e => onWeightChange(`parcial_${p}`, e.target.value)}
              disabled={isReadOnly}
              placeholder="0"
              className="w-14 h-8 text-center text-sm font-bold border-2 border-orange-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-orange-400 bg-white"
              data-testid={`att-weight-p${p}`}
            />
            <span className="text-sm text-orange-500">%</span>
          </div>
        ))}
      </div>
      {hasAnyWeight ? (
        <div className="overflow-x-auto">
          <table className="w-full border-collapse">
            <thead>
              <tr className="border-b-2 border-orange-200 bg-orange-50">
                <th className="text-left py-2 px-3 text-sm font-semibold text-orange-700 min-w-[180px]">Alumno</th>
                {P_KEYS.map((k, i) => parseWeight(attWeights[k]) > 0 && (
                  <th key={k} className="text-center py-2 px-2 text-xs font-semibold text-orange-700 min-w-[100px]">
                    <div>Parcial {i + 1}</div>
                    <div className="text-orange-400 font-normal">Peso: {parseWeight(attWeights[k])}%</div>
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {students.map(st => (
                <tr key={st.id} className="border-b border-slate-200 hover:bg-slate-50">
                  <td className="py-2 px-3 text-sm font-medium text-slate-900">{st.name}</td>
                  {P_KEYS.map((k, i) => {
                    const w = parseWeight(attWeights[k]);
                    if (w <= 0) return null;
                    const att = (attendanceByParcial[st.id] || [])[i];
                    if (!att || att.pct === null) return <td key={k} className="text-center py-2 px-2 text-sm text-slate-400" data-testid={`att-grade-${st.id}-p${i + 1}`}>--</td>;
                    const grade = (att.pct / 100) * (w / 100) * 10;
                    return (
                      <td key={k} className={`text-center py-2 px-2 text-sm font-bold rounded ${gradeColor(grade, w)}`} data-testid={`att-grade-${st.id}-p${i + 1}`}>
                        {grade.toFixed(2)}
                      </td>
                    );
                  })}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <p className="text-sm text-slate-500 text-center py-3">Sin peso asignado: las asistencias no afectan la calificación.</p>
      )}
    </div>
  );
};
